import { Typography } from '@mui/material';
import { styled } from '@mui/system';

interface RootDivProps {
  isDelivery: boolean;
}

const RootDiv = styled('div')<RootDivProps>(({ isDelivery }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'white',
  border: '1px solid #EAEAEA',
  borderRadius: '10px',
  margin: isDelivery ? '17px 0px 0 0' : '17px 0px 97px 0',
}));

const TitleTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.15px',
  color: '#414046',
  marginBottom: '12px',
  textAlign: 'left',
  marginLeft: '12px',
  marginTop: '12px',
});

const SubTitleTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 600,
  fontSize: '13px',
  lineHeight: '19.5px',
  letterSpacing: '0.16px',
  color: '#414046',
  marginBottom: '12px',
  textAlign: 'left',
  marginLeft: '12px',
  marginTop: '12px',
});

const DivisionLine = styled('div')({
  height: '1px',
  backgroundColor: '#EAEAEA',
});

export { RootDiv, TitleTypography, SubTitleTypography, DivisionLine };
